var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M371.6,438.8c-22.3-33.7-44.3-67-66.3-100.3c-36.1-54.5-72.1-109.1-108.2-163.6c-5-7.5-18.7-11.4-26.2-6.8 c-2.3,1.4-4.4,5.1-4.5,7.7c-0.3,56.4-0.3,112.8-0.3,169.2c0,6,3.1,9.3,9.3,9.2c0.5,0,1,0,1.5,0c15,0.2,16.3-1,16.4-15.9 c0.1-33.7,0.2-67.4,0.3-101.1c0-6.1,0-12.2,0-19.4c54.4,77.4,107.9,153.7,161.4,229.8c-59.7,38.6-189.8,47.8-275.6-51.1 c-84.9-97.9-68.3-248.9,36.2-327C220.4-8.6,370,18.9,440.2,129.6C506.3,233.7,475.3,373.6,371.6,438.8z M330.6,323.5 c0.7-1.2,1.1-1.6,1.1-2c0-50.7,0.1-101.4-0.1-152c0-2.2-1.5-6.2-2.7-6.4c-6.5-1-13.3-2.2-19.5-1c-2.3,0.4-4.7,7.2-4.8,11.1 c-0.4,35-0.4,69.9-0.3,104.9c0,2.8,0.6,6.1,2.1,8.4C314.2,298.7,322.2,310.7,330.6,323.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.343a3adb2e2fe53ec7f35402b87dd95d.svg";
export { ForwardRef as ReactComponent };